import { render, staticRenderFns } from "./RedeemProdukEdit.vue?vue&type=template&id=8778866e&scoped=true"
import script from "./RedeemProdukEdit.vue?vue&type=script&lang=js"
export * from "./RedeemProdukEdit.vue?vue&type=script&lang=js"
import style0 from "./RedeemProdukEdit.vue?vue&type=style&index=0&id=8778866e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8778866e",
  null
  
)

export default component.exports